import { ApiConfigurationDataService } from '../services/api-configuration-data.service';

export function fetchApiConfigurationDataFactory(
    apiConfigurationDataService: ApiConfigurationDataService
) {
    return () => apiConfigurationDataService.getShellAndConfigPromise();
}
